/**
 * Whether the user's device prefers 24-hour time, based on the raw
 * `navigator.language` rather than the app's allowlisted locale set.
 *
 * Reads `Intl.DateTimeFormat(...).resolvedOptions().hourCycle`, so CLDR data
 * answers the question for every locale — de-DE, ja-JP, fr-FR, en-GB all
 * resolve to true even when they are not registered in
 * `constants/supported-locales.js`. The allowlist still drives currency
 * selection and date-token formatting via `moment.locale()`; time-of-day
 * follows CLDR universally.
 *
 * @returns {boolean}
 */
function deviceUses24Hour() {
  try {
    const locale = window.navigator.language || 'en-US';
    const { hourCycle } = new Intl.DateTimeFormat(locale, { hour: 'numeric' }).resolvedOptions();

    return hourCycle === 'h23' || hourCycle === 'h24';
  }
  catch {
    return false;
  }
}



export default deviceUses24Hour;
